// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EePT","toggle":"styles_toggle__2hx1V","preview":"styles_preview__IDQ0P"};